<template>
  <customize-header class="page-schedule-survey">
    <template #header>
      <top-bar show-header
               title="完善信息"
      >
        <template #header-right>
          <span class="skip"
                :class="{ 'hide-download-bar': hideDownloadBar }"
                v-ym-report:LEARNING_INFO_SKIP_CLICK=""
                @click="handleSkip"
          >
            跳过
          </span>
        </template>
      </top-bar>
    </template>
    <base-info :age-list="age.list"
               :sex-list="sex.list"
               :params="params"
               @baseInfo="handleBaseInfo"
               v-if="showBaseInfo"
    />
    <result-info :list="baseInfoResult"
                 desc="孩子的性别年龄"
                 @click.native="handleBackToSelectPage('baseInfo')"
                 v-if="showBaseInfoResult"
    />
    <grid-select :max="interest.max"
                 :list="interest.list"
                 desc="孩子的兴趣"
                 :type="interest.type"
                 :selected-key-list="selectedKeyList"
                 :selected-value-list="interestResult"
                 @selectInfo="handleSelectInfo"
                 v-if="showInterest"
    />
    <result-info class="interest-result"
                 :list="interestResult"
                 desc="孩子的兴趣"
                 @click.native="handleBackToSelectPage('interest')"
                 v-if="showInterestResult"
    />
    <grid-select :max="ability.max"
                 :list="ability.list"
                 desc="希望提升的能力"
                 :type="ability.type"
                 @selectInfo="handleSelectInfo"
                 v-if="showAbility"
    />
  </customize-header>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getLearningSurveyInfo, getLearningSurveyResult } from '@/services/learning';
  import ResultInfo from '@/pages/LearningSurvey/components/ResultInfo';
  import BaseInfo from '@/pages/LearningSurvey/components/BaseInfo';
  import GridSelect from '@/pages/LearningSurvey/components/GridSelect';
  import TopBar from '@/components/TopBar';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import { PLAN_SURVEY_FINISH_STATUS, LIMIT } from '@/utils/constant';
  import {
    setToLocalStorage,
    getUID,
    getFromLocalStorage,
    getQuery,
    getStorageRedirect,
  } from '@/utils';

  export default {
    name: 'LearningSurvey',
    metaInfo: {},
    components: {
      ResultInfo,
      BaseInfo,
      GridSelect,
      TopBar,
      CustomizeHeader,
    },
    data() {
      return {
        sex: {
          list: [],
        },
        age: {
          list: [],
        },
        interest: {
          max: 3,
          list: [],
          type: 'interest',
        },
        ability: {
          max: 3,
          list: [],
          type: 'ability',
        },
        showBaseInfo: false,
        showBaseInfoResult: false,
        baseInfoResult: [],

        showInterest: false,
        showInterestResult: false,
        interestResult: [],

        showAbility: false,

        start: 0,

        sexKey: '',
        sexValue: '',
        ageKey: '',
        ageValue: '',
        birthday: '',

        params: {
          sex: '',
          sexValue: '',
          age: '',
          ageValue: '',
          birthday: '',
          changeType: false,
          currentDate: new Date(),
        },

        selectedKeyList: [],
      };
    },
    computed: {
      ...mapGetters([
        'downloadBarInfo',
      ]),
      query() {
        return getQuery(this.$route.query);
      },
      hideDownloadBar() {
        return JSON.parse(getFromLocalStorage(this.downloadBarInfo.key));
      },
    },
    methods: {
      async fetchSurvey() {
        const data = await getLearningSurveyInfo();
        this.age = data.age;
        this.sex = data.sex;
        this.interest = data.interest;
        this.ability = data.ability;

        this.$store.dispatch('toggleShowBack', false);
        this.showBaseInfo = true;
      },
      handleBaseInfo(params) {
        this.params = Object.assign({}, this.params, params);
        this.showBaseInfo = false;
        this.sexValue = params.sexValue;
        this.ageValue = params.ageValue;
        this.birthday = params.birthday;
        const desc = `${params.sexValue} / ${params.ageValue}`;
        this.baseInfoResult = [].concat(desc);

        this.sexKey = params.sex;
        this.ageKey = params.age;
        this.showBaseInfoResult = true;
        this.showInterest = true;
      },
      handleInterestInfo(params) {
        const interest = {
          interest: params.keyList.join(),
        };
        this.params = Object.assign({}, interest, this.params);
        this.interestResult = params.valueList;
        this.selectedKeyList = params.keyList;
        this.showInterest = false;

        this.showInterestResult = true;
        this.showAbility = true;
      },
      async handleAbilityInfo(params) {
        const ability = {
          ability: params.keyList.join(),
        };
        this.params = Object.assign({}, ability, this.params);
        // 设置调查完成状态
        this.handleSurveyFinishStatus();
        const param = Object.assign({
          start: this.start,
          limit: LIMIT,
        }, this.params);
        await getLearningSurveyResult(param);
        this.handleShowPage();
      },
      handleSelectInfo(params) {
        if (params.type === 'interest') {
          this.handleInterestInfo(params);
        }
        if (params.type === 'ability') {
          this.handleAbilityInfo(params);
        }
      },
      handleBackToSelectPage(type) {
        if (type === 'baseInfo') {
          this.showBaseInfoResult = false;
          this.showInterest = false;
          this.showInterestResult = false;
          this.showAbility = false;

          this.showBaseInfo = true;
        }
        if (type === 'interest') {
          this.showInterestResult = false;
          this.showAbility = false;

          this.showInterest = true;
        }
      },
      handleSkip() {
        this.handleSurveyFinishStatus();
        this.handleShowPage();
      },
      handleSurveyFinishStatus() {
        const userId = getUID();
        setToLocalStorage(`${PLAN_SURVEY_FINISH_STATUS}-${userId}`, 'finished');
      },
      handleShowPage() {
        const { redirectTo } = this.query;
        if (redirectTo && redirectTo !== '') {
          const path = getStorageRedirect(redirectTo);
          this.$router.replace({
            path,
          });
          return;
        }

        this.$router.replace({ name: 'Learning' });
      },
    },
    created() {
      this.fetchSurvey();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-schedule-survey {
    min-height: 100%;
    background: @color-white;
  }

  .skip {
    font-size: @font-size-medium;
    color: @color-text-light;
    &.hide-download-bar {
      top: @size-small;
    }
  }

  .interest-result {
    margin-top: @size-small;
  }

</style>
